<div class="flex h-full flex-col">
  @if (!isAnyFolders) {
    <div class="flex h-full">
      <p class="m-[auto] text-center">
        {{ 'noMailAccountIsAvailableYet' | translate }}
      </p>
    </div>
  } @else {
    <app-mails-content
      class="flex h-full w-full flex-1 flex-col gap-2"></app-mails-content>
  }
</div>
